import { TagManager } from "@/utils/trackers";

export const enum GAEvents {
    Purchase = "purchase",
    ViewCart = "view_cart",
    BeginCheckout = "begin_checkout",
    SignUp = "sign_up",
    Gender = "web_onboarding_gender",
    AddToCart = "add_to_cart",
}

// Events that should only be sent once
const ONE_TIME_EVENTS = new Set<GAEvents>([]);

// Track which one-time events have been sent
const sentEvents = new Set<string>();

export const sendMetrics = (...args: Parameters<(typeof TagManager)["track"]>) => {
    const [eventName] = args;

    // Check if this is a one-time event that has already been sent
    if (ONE_TIME_EVENTS.has(eventName as GAEvents) && sentEvents.has(eventName)) {
        return;
    }

    TagManager.track(...args);

    // Mark one-time events as sent
    if (ONE_TIME_EVENTS.has(eventName as GAEvents)) {
        sentEvents.add(eventName);
    }
};
